import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useMapType, MapType } from '@/component/map/MapContext'
import Menu, { WMOption } from '@/component/menu/Menu'

interface MapSwitcherProps {
    className?: string
}

const MapSwitcher: React.FC<MapSwitcherProps> = ({ className }) => {
    const { t } = useTranslation()
    const { mapType, setMapType } = useMapType()
    const currentMapName = mapType === 'google' ? 'Google' : 'Baidu'

    const menuItems: WMOption[] = useMemo(() => [
        {
            id: 'google',
            text: 'Google Maps',
            onClick: () => setMapType('google' as MapType),
        },
        {
            id: 'baidu',
            text: 'Baidu 百度地图',
            onClick: () => setMapType('baidu' as MapType),
        },
    ], [setMapType])

    return (
        <Menu
            className={className}
            items={menuItems}
            ariaLabel={t('map.switcher.ariaLabel', { name: currentMapName })}
            render={
                <div className="map-switcher__trigger flex min-h-[40px] items-center gap-[7px] px-[10px] text-[14px] font-bold">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M10 2C6.13 2 3 5.13 3 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7z" fill="currentColor"/>
                        <circle cx="10" cy="9" r="3" fill="white"/>
                    </svg>
                    <span>{t('map.switcher.label', { name: currentMapName })}</span>
                </div>
            }
        />
    )
}

export default MapSwitcher
